import { render } from "./ProjectNew.vue?vue&type=template&id=2cd424d7"
import script from "./ProjectNew.vue?vue&type=script&lang=js"
export * from "./ProjectNew.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__